import {nodeNameToRule} from "../flavour/openlexia/rules.mjs";

export class NodeHtmlFormatter {

  constructor(nodeRules) {
    if(nodeRules.length == 0) throw new Error('node rules cannot be empty')
  }

  format(rootNode, idProvider) {
    if(rootNode === null || rootNode.children.length < 1) return "<div class='lecture'></div>"

    var content = ""
    for(const child of rootNode.children) {
      content += this.toHtml(child, idProvider)
    }

    return "<div class='lecture'>" + content + "</div>"

  }

  toHtml(node, idProvider) {
    // find the rule that apply
    // call the HTML formatter of the rule with a callback to this method
    // each rule should handle how formating is done for the children nodes
    return nodeNameToRule[node.name].toHtml(node, this.toHtml.bind(this), idProvider)
  }

}
